import { apiResponseMiddleware } from "@/middleware/api-response";
import toast from "react-hot-toast";

import { api } from "./axios-instance";

const API_ENDPOINT = "/api/RoleUser";

export const getAllRoleUsers = async (
  roleId: number,
  { page, size, search }: { page: number; size: number; search?: string }
) => {
  return await apiResponseMiddleware<
    {
      id: number;
      name: string;
      userName: string;
      isAccess: boolean;
    }[]
  >(
    api.get(`${API_ENDPOINT}/user`, {
      params: {
        RoleId: roleId,
        pageSize: size,
        pageNumber: page,
        search
      }
    }),
    () => { },
    {
      showToast: false
    }
  );
};

export const getRoleUsersJustAccess = async (
  roleId: number,
  { page, size, search }: { page: number; size: number, search?: string }
) => {
  return await apiResponseMiddleware<
    {
      id: number;
      name: string;
      userName: string;
      isAccess: boolean;
    }[]
  >(
    api.get(`${API_ENDPOINT}/user/justAccess`, {
      params: {
        roleId,
        pageSize: size,
        pageNumber: page,
        search: search
      }
    }),
    () => { },
    {
      showToast: false
    }
  );
};

export interface UserWithRoleType {
  professorId: number;
  userId: number;
  userName: string;
  fullName: string | null;
  imageUrl: string | null;
  isActive: boolean;
  roleId: number;
  roleNameFa: string | null;
  roleNameEn: string | null;
}

export const getUsersWithRoles = async (
  params: { pageSize?: number; pageNumber?: number; search?: string } = {}
) => {
  return await apiResponseMiddleware<UserWithRoleType[]>(
    api.get(`${API_ENDPOINT}/withRoles`, {
      params: {
        pageSize: params.pageSize ?? 100,
        pageNumber: params.pageNumber ?? 1,
        search: params.search || undefined
      }
    }),
    () => { },
    { showToast: false }
  );
};

export const updateRoleUsers = async (roleId: number, userIds: number[]) => {
  return apiResponseMiddleware(
    api.post(`${API_ENDPOINT}/create/allByRoleId/${roleId}`, userIds, {
      headers: {
        "Content-Type": "application/json"
      }
    }),
    () => {
      toast.success("کاربر ها با موفقیت ذخیره شد", {
        id: "api-middleware"
      });
    },
    {
      showToast: true
    }
  );
};
